import { render } from "./editMenu.vue?vue&type=template&id=5b1e375b"
import script from "./editMenu.vue?vue&type=script&lang=js"
export * from "./editMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__